export const API_URL = "https://dev.api.s10drd.com";
export const SIGN_API_URL = "https://dev.api.s10drd.com";


